module.exports = " <div :class=classes> <div class=field-inner> <div v-if=isReadOnly class=read-only-overlay :title=\"translate('cp.read_only')\"></div> <label class=block> {{ display }} <i class=required v-if=isRequired>*</i> </label> <small class=help-block v-if=instructions v-html=\"instructions | markdown\"></small> <component v-ref:field :is=componentName :config=config :autofocus=autofocus></component> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/publish/MetaField.vue
// module id = 313
// module chunks = 0